
interface TourInfoProps {
  description: string;
  highlights: Array<{
    icon: string;
    label: string;
    value: string;
  }>;
  includes: string[];
  excludes: string[];
}

export default function TourInfo({ description, highlights, includes, excludes }: TourInfoProps) {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-5 gap-12">
          <div className="col-span-3">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-3 h-3 bg-[#1A237E] rotate-45"></span>
              <span className="text-sm font-bold text-[#1A237E] tracking-wider">OVERVIEW</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">투어 소개</h2>
            <p className="text-gray-600 leading-relaxed text-base mb-10">{description}</p>

            <div className="grid grid-cols-2 gap-4">
              {highlights.map((item, idx) => (
                <div key={idx} className="bg-[#FAFAF8] rounded-xl p-5 flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#E0F7FA] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#00BCD4] text-xl`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-0.5">{item.label}</div>
                    <div className="text-sm font-bold text-gray-900">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-2">
            <div className="bg-[#F0FDF9] rounded-2xl p-8 mb-6">
              <h3 className="text-lg font-bold text-gray-900 mb-5 flex items-center gap-2">
                <i className="ri-check-double-line text-[#00BCD4]"></i>
                포함 사항
              </h3>
              <ul className="space-y-3">
                {includes.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-sm text-gray-700">
                    <div className="w-5 h-5 bg-[#00BCD4] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-lg font-bold text-gray-900 mb-5 flex items-center gap-2">
                <i className="ri-close-circle-line text-gray-400"></i>
                불포함 사항
              </h3>
              <ul className="space-y-3">
                {excludes.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-sm text-gray-500">
                    <div className="w-5 h-5 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-close-line text-white text-xs"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
